/**
 * Created by zzy on 2019/8/7.
 */
import { ArcgisMap } from 'components'
import ShowStreamNodeModal from '../../common/showStreamNodeModal'
import VideoPlayerModal from '../../common/VideoPlayerModal'
import { debounce, throttle, loadJs } from '@/utils/public'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件

export default {
  name: 'deviceMap',
  data() {
    return {
      mapLoaded: false,
      mapUrl: this.$globalConfig.mapUrl,
      mapZoom: this.$globalConfig.mapZoom,
      mapCenter: this.$globalConfig.mapCenter,
      gisMarkers: [],
      currentGismarker: null,
      selectedGismarkers: [],
      gisMarkerParams: {
        regionId: 0,
        resourceId: 0,
        resourceKind: 21,
        resourceSubType: 255,
        minZoom: this.mapZoom,
        geographyCoordinateFiltered: 0, // 地理坐标过滤
        minLongitude: null,
        maxLongitude: null,
        minLatitude: null,
        maxLatitude: null,
        filterText: '',
        encoderStateRequired: 1, // 要求返回监控设备状态
        streamServerInfoRequired: 1, // 要求返回流媒体服务信息
        pageNum: 1,
        pageSize: 1000
      },
      // 标记定位过滤
      filterText: '',
      filteredGisMarkers: [],
      // 视频节点信息弹窗
      streamNodeModalOpen: false,
      // 视频播放器弹窗
      videoPlayerModalOpen: false,
      videoPlayerModalVideoOpen: false // 打开视频标识
    }
  },
  components: {
    ArcgisMap,
    ShowStreamNodeModal,
    VideoPlayerModal
  },
  mixins: [
    ssoLoginMixin
  ],
  created() {
    // 由于加载arcgis相关jis文件后，加载flv文件无法正常初始化，提前加载
    loadJs('static/js/oss-player/flv.min.js', () => {})
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    // 查询gis标记列表
    getGisMarkerList() {
      this.gisMarkerParams.regionId = 0
      this.gisMarkerParams.resourceId = 0
      this.gisMarkerParams.minZoom = this.mapZoom
      this.gisMarkerParams.geographyCoordinateFiltered = 1
      this.gisMarkerParams.minLongitude = this.$refs.arcgisMap.geographicExtent.xmin
      this.gisMarkerParams.minLatitude = this.$refs.arcgisMap.geographicExtent.ymin
      this.gisMarkerParams.maxLongitude = this.$refs.arcgisMap.geographicExtent.xmax
      this.gisMarkerParams.maxLatitude = this.$refs.arcgisMap.geographicExtent.ymax
      this.gisMarkerParams.filterText = ''
      this.gisMarkerParams.pageSize = 1000
      this.$http(this.$api.gisMarkerList, this.gisMarkerParams).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            let findIndex = this.gisMarkers.findIndex(item2 => { // 检测元素是否重复
              return item2.id === item.id && item2.resourceKind === item.resourceKind
            })
            if (findIndex < 0 && item.latitude && item.longitude) {
              this.gisMarkers.push(item)
              this.$refs.arcgisMap.addImageGraphic(item.id, 'streamNode', item)
              this.$refs.arcgisMap.addGraphicClickEventHandler(this.handleGisMarkerClick)
            }
          })
        }
      })
      console.log('>>> 查询gis标记列表')
    },
    // 根据过滤文本查询返回gis标记列表
    filterGisMarkerList(filterText, callback) {
      this.filteredGisMarkers = []
      this.gisMarkerParams.regionId = 0
      this.gisMarkerParams.resourceId = 0
      this.gisMarkerParams.minZoom = 0
      this.gisMarkerParams.geographyCoordinateFiltered = 0
      this.gisMarkerParams.filterText = filterText
      this.gisMarkerParams.pageSize = 20
      this.$http(this.$api.gisMarkerList, this.gisMarkerParams).then(res => {
        if (res.code === 200) {
          this.filteredGisMarkers = res.data
          if (this.filteredGisMarkers.length) {
            this.filteredGisMarkers.forEach(item => { // 添加value字段
              item.value = item.name
            })
          }
        }
        if (callback) { // 回调
          callback(this.filteredGisMarkers)
        }
      })
    },
    // 添加并定位gis标记
    locateGisMarker(gisMarker) {
      let findIndex = this.gisMarkers.findIndex(item => { // 检测元素是否重复
        return item.id === gisMarker.id && item.resourceKind === gisMarker.resourceKind
      })
      if (findIndex < 0 && gisMarker.latitude && gisMarker.longitude) {
        this.gisMarkers.push(gisMarker)
        this.$refs.arcgisMap.addImageGraphic(gisMarker.id, 'streamNode', gisMarker)
        this.$refs.arcgisMap.addGraphicClickEventHandler(this.handleGisMarkerClick)
      }

      this.$refs.arcgisMap.locateImageGraphic(gisMarker.id, 'streamNode')
      this.currentGismarker = gisMarker
    },
    // 地图加载完成
    handleMapLoad: function () {
      this.mapLoaded = true
      // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
      this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
        // 查询gis标记
        this.getGisMarkerList()
      })
    },
    // 地图已卸载
    handleMapUnload: function () {
    },
    // 地图范围改变
    handleExtentChange: function () {
      if (!this.mapLoaded) {
        return
      }
      // 启用防抖机制
      debounce(() => {
        this.getGisMarkerList()
      }, 1000)
    },
    // 根据过滤文本查询返回gis标记列表
    querySearch(queryString, callback) {
      // 启用防抖机制
      debounce(() => {
        if (queryString === '') { // 过滤文本为空不做查询
          return
        }
        this.filterGisMarkerList(queryString, callback)
      }, 2000)
    },
    // 点击选项时定位标记
    handleSelect(item) {
      this.locateGisMarker(item)
    },
    // 单击gis标记
    handleGisMarkerClick: function (graphic) {
      // 启用节流阀机制(否则一次单击触发5次事件，原因不知）
      throttle(() => {
        this.currentGismarker = graphic.attributes['data']
        this.streamNodeModalOpen = true
      }, 200)
    },
    // 地图框选开始
    handleBoxSelectStart() {
      this.videoPlayerModalVideoOpen = false
      this.selectedGismarkers = []
    },
    // 地图框选完成
    handleBoxSelectComplete(selectedImageGraphics) {
      if (selectedImageGraphics.length === 0) {
        return
      }
      this.selectedGismarkers = selectedImageGraphics.map(item => { return item.attributes.data })
      if (!this.videoPlayerModalOpen) {
        this.videoPlayerModalOpen = true
      } else { // 重新打开视频
        this.videoPlayerModalVideoOpen = true
      }
    },
    // 视频节点窗口关闭
    handleStreamNodeModalCancel() {
      this.streamNodeModalOpen = false
    },
    // 视频播放器窗口关闭
    handleVideoPlayerModalCancel() {
      this.videoPlayerModalOpen = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/monitoring/deviceMap/DeviceMap.js